<template functional>
  <span
    class="stamp"
    :style="`transform: translate(-50%, -50%) rotate(${props.rotation}deg);
   color: var(--v-${props.color}-base);
   border: ${props.border} var(--v-${props.color}-base);
  border-radius: ${props.radius};
  `"
    ><slot></slot>
  </span>
</template>

<script>
export default {
  props: ["rotation", "color", "border", "radius"],
};
</script>

<style scoped>
.stamp {
  position: absolute;
  text-align: center;
  right: 2%;
  font-size: 1em;
  font-weight: 700;
  display: inline-block;
  padding: 0.125rem 0.5rem;
  text-transform: uppercase;
  mix-blend-mode: multiply;
  overflow: hidden;
  user-select: none;
  opacity: 0.5;
  width: 120px;
  top: 50%;
  left: 70%;
}
</style>
